var React = require('react');

function SignIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0c6.628 0 12 5.372 12 12s-5.372 12-12 12C5.373 24 0 18.628 0 12S5.373 0 12 0zm-.187 12.424c-2.961 0-5.409 2.306-5.806 5.3a.765.765 0 00.764.86h10.083l.106-.008a.763.763 0 00.658-.851c-.397-2.995-2.845-5.3-5.805-5.3zm.002-7.174c-1.727 0-3.128 1.379-3.128 3.08 0 1.7 1.4 3.08 3.128 3.08 1.726 0 3.128-1.38 3.128-3.08 0-1.701-1.402-3.08-3.128-3.08z","fillRule":"evenodd"}));
}

SignIn.defaultProps = {"width":"24","height":"24"};

module.exports = SignIn;

SignIn.default = SignIn;
